var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoEndedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3464 12C23.3464 18.2104 18.2908 23.25 12.0482 23.25C5.80554 23.25 0.75 18.2104 0.75 12C0.75 5.78963 5.80554 0.75 12.0482 0.75C18.2908 0.75 23.3464 5.78963 23.3464 12Z",
    stroke: "#21C46C",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_415_1452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.4585 12.5714L10.3271 15.4285L16.0644 9.71423",
    stroke: "#21C46C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_415_1452"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.7694,
    height: 13.7143,
    fill: "white",
    transform: "translate(4.58984 5.71423)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoEndedIcon);
export default __webpack_public_path__ + "static/media/videoEndedIcon.5c9fa581.svg";
export { ForwardRef as ReactComponent };